export const buildUploadToken = () => Symbol('upload token');

export const buildObjectUrl = (file: File) => URL.createObjectURL(file);
